import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ContactDirectory = ({ onCallContact }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const contacts = [
  {
    id: 1,
    name: "Zeynep Aktaş",
    phone: "+90 532 111 2222",
    email: "zeynep.aktas@email.com",
    company: "ABC Teknoloji",
    category: "customer",
    lastContact: new Date(Date.now() - 86400000),
    notes: "VIP müşteri, özel ilgi gerektirir",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19c152708-1762274558818.png",
    avatarAlt: "Professional headshot of woman with brown hair in business attire"
  },
  {
    id: 2,
    name: "Burak Özdemir",
    phone: "+90 533 333 4444",
    email: "burak.ozdemir@firma.com",
    company: "XYZ Holding",
    category: "lead",
    lastContact: new Date(Date.now() - 172800000),
    notes: "Ürün demosu talep etti",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10d8d5691-1762273548301.png",
    avatarAlt: "Professional headshot of man with dark hair in navy suit"
  },
  {
    id: 3,
    name: "Elif Yıldırım",
    phone: "+90 534 555 6666",
    email: "elif.yildirim@sirket.com",
    company: "DEF Danışmanlık",
    category: "customer",
    lastContact: new Date(Date.now() - 259200000),
    notes: "Teknik destek gereksinimi var",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_126100cab-1762273569433.png",
    avatarAlt: "Professional headshot of woman with blonde hair smiling"
  },
  {
    id: 4,
    name: "Murat Kılıç",
    phone: "+90 535 777 8888",
    email: "murat.kilic@email.com",
    company: "GHI Yazılım",
    category: "prospect",
    lastContact: new Date(Date.now() - 345600000),
    notes: "Fiyat teklifi bekleniyor",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_12d77f22e-1762273581295.png",
    avatarAlt: "Professional headshot of man with beard in gray shirt"
  },
  {
    id: 5,
    name: "Seda Çelik",
    phone: "+90 536 999 0000",
    email: "seda.celik@firma.com",
    company: "JKL Pazarlama",
    category: "customer",
    lastContact: new Date(Date.now() - 432000000),
    notes: "Yenileme sözleşmesi görüşülecek",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10c75be77-1762273997956.png",
    avatarAlt: "Professional headshot of woman with dark hair in white blouse"
  }];


  const categories = [
  { value: 'all', label: 'Tüm Kişiler', count: contacts?.length },
  { value: 'customer', label: 'Müşteriler', count: contacts?.filter((c) => c?.category === 'customer')?.length },
  { value: 'lead', label: 'Potansiyeller', count: contacts?.filter((c) => c?.category === 'lead')?.length },
  { value: 'prospect', label: 'Adaylar', count: contacts?.filter((c) => c?.category === 'prospect')?.length }];


  const filteredContacts = contacts?.filter((contact) => {
    const matchesSearch = contact?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
    contact?.phone?.includes(searchTerm) ||
    contact?.company?.toLowerCase()?.includes(searchTerm?.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || contact?.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const formatLastContact = (date) => {
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 1) return 'Dün';
    if (diffDays < 7) return `${diffDays} gün önce`;
    if (diffDays < 30) return `${Math.ceil(diffDays / 7)} hafta önce`;
    return `${Math.ceil(diffDays / 30)} ay önce`;
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'customer':
        return 'bg-green-100 text-green-800';
      case 'lead':
        return 'bg-blue-100 text-blue-800';
      case 'prospect':
        return 'bg-yellow-100 text-yellow-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getCategoryLabel = (category) => {
    switch (category) {
      case 'customer':
        return 'Müşteri';
      case 'lead':
        return 'Potansiyel';
      case 'prospect':
        return 'Aday';
      default:
        return 'Bilinmiyor';
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-subtle border border-slate-200 p-6">
      {/* Header */}
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-slate-900 mb-2">Kişi Rehberi</h3>
        <p className="text-sm text-slate-600">Müşteri ve potansiyel kişiler</p>
      </div>
      {/* Search */}
      <div className="mb-4">
        <Input
          type="search"
          placeholder="İsim, telefon veya şirket ara..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e?.target?.value)}
          className="w-full" />

      </div>
      {/* Category Filter */}
      <div className="mb-6">
        <div className="flex flex-wrap gap-2">
          {categories?.map((category) =>
          <button
            key={category?.value}
            onClick={() => setSelectedCategory(category?.value)}
            className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-150 ${
            selectedCategory === category?.value ?
            'bg-primary text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`
            }>

              {category?.label} ({category?.count})
            </button>
          )}
        </div>
      </div>
      {/* Contacts List */}
      <div className="space-y-3 max-h-96 overflow-y-auto">
        {filteredContacts?.map((contact) =>
        <div
          key={contact?.id}
          className="border border-slate-200 rounded-lg p-4 hover:bg-slate-50 transition-colors duration-150">

            <div className="flex items-start space-x-4">
              {/* Avatar */}
              <div className="w-12 h-12 rounded-full overflow-hidden bg-slate-200 flex-shrink-0">
                <img
                src={contact?.avatar}
                alt={contact?.avatarAlt}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.src = '/assets/images/no_image.png';
                }} />

              </div>

              {/* Contact Info */}
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h4 className="font-semibold text-slate-900 truncate">
                      {contact?.name}
                    </h4>
                    <p className="text-sm text-slate-600 truncate">
                      {contact?.company}
                    </p>
                  </div>
                  <span className={`inline-flex items-center px-2 py-1 text-xs font-medium rounded-full ${getCategoryColor(contact?.category)}`}>
                    {getCategoryLabel(contact?.category)}
                  </span>
                </div>

                <div className="space-y-1 mb-3">
                  <div className="flex items-center space-x-2 text-sm text-slate-600">
                    <Icon name="Phone" size={14} />
                    <span>{contact?.phone}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-sm text-slate-600">
                    <Icon name="Mail" size={14} />
                    <span className="truncate">{contact?.email}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-xs text-slate-500">
                    <Icon name="Clock" size={12} />
                    <span>Son iletişim: {formatLastContact(contact?.lastContact)}</span>
                  </div>
                </div>

                {/* Notes */}
                {contact?.notes &&
              <div className="mb-3">
                    <p className="text-xs text-slate-600 bg-slate-50 rounded p-2">
                      <Icon name="StickyNote" size={12} className="inline mr-1" />
                      {contact?.notes}
                    </p>
                  </div>
              }

                {/* Actions */}
                <div className="flex items-center space-x-2">
                  <Button
                  variant="default"
                  size="xs"
                  onClick={() => onCallContact(contact)}
                  iconName="Phone"
                  iconPosition="left">

                    Ara
                  </Button>
                  <Button
                  variant="outline"
                  size="xs"
                  iconName="MessageSquare"
                  iconPosition="left">

                    Mesaj
                  </Button>
                  <Button
                  variant="ghost"
                  size="xs"
                  iconName="Eye"
                  iconPosition="left">

                    Detay
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {filteredContacts?.length === 0 &&
      <div className="text-center py-8">
          <Icon name="Users" size={48} className="mx-auto text-slate-300 mb-4" />
          <p className="text-sm text-slate-600">
            {searchTerm ? 'Arama kriterlerine uygun kişi bulunamadı' : 'Kişi rehberi boş'}
          </p>
        </div>
      }
    </div>);

};

export default ContactDirectory;